<template>
  <div>
    <ca-heading text="Empregador" />

    <ca-page>
      <ca-loader v-if="showLoading" />

      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Tipo Inscrição">
              <ca-select v-model="company.registrationType.name" disabled>
                <ca-option
                  v-for="insciptionType in misc.companyInscriptionType"
                  :key="insciptionType.value"
                  :value="insciptionType.value">
                  {{ insciptionType.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="CNPJ">
              <ca-input
                v-model="company.registration"
                mask-pattern="99.999.999/9999-99"
                maxlength="18"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Razão Social">
              <ca-input
                v-model="company.name"
                maxlength="115"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Classificação Tributária">
              <ca-select
                v-model="company.taxationClass.name"
                required
                :on-change="refreshForm">
                <ca-option
                  v-for="classification in misc.tributaryClassifications"
                  :key="classification.value"
                  :value="classification.name">
                  {{ classification.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Natureza Jurídica">
              <ca-search-select
                v-model="company.legalNature.name"
                placeholder="Selecione"
                required
                :on-change="onChangeLegalNature">
                <ca-option
                  v-for="nature in misc.legalNatures"
                  :key="nature.name"
                  :value="nature.name">
                  {{ nature.description }}
                </ca-option>
              </ca-search-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Porte da empresa">
              <ca-select
                v-model="company.companySize"
                required
                compare-value-by="name"
                placeholder="Selecione"
                :on-change="refreshForm">
                <ca-option
                  v-for="companySize in misc.companySizes"
                  :key="companySize.name"
                  :value="companySize">
                  {{ companySize.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="4">
            <ca-field
              label="Contagem de dias para Mensalistas">
              <ca-select v-model="company.dayCountType.name" :on-change="refreshForm">
                <ca-option
                  v-for="option in misc.monthlyCountingDays"
                  :key="option.value"
                  :value="option.value">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col size="2" class="dp-ca-u-margin-top">
            <ca-button full-width @click="onReferenceDaysCounting">Referência</ca-button>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Cooperativa">
              <ca-select
                v-model="company.cooperativeType.name"
                required
                :on-change="refreshForm">
                <ca-option
                  v-for="option in misc.cooperativeCallsigns"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="3">
            <ca-field label="Construtora">
              <ca-row>
                <ca-col size="4">
                  <ca-checkbox
                    v-model="company.indConstru"
                    label="Sim" />
                </ca-col>
              </ca-row>
            </ca-field>
          </ca-col>

          <ca-col size="3">
            <ca-field label="Desoneração na Folha">
              <ca-row>
                <ca-col size="4">
                  <ca-checkbox
                    v-model="company.indExemptionPayroll"
                    label="Sim" />
                </ca-col>
              </ca-row>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Pagamento da Folha no 5º Dia Útil do Próximo Mês">
              <ca-row>
                <ca-col size="4">
                  <ca-checkbox
                    v-model="company.indCashRegime"
                    label="Sim" />
                </ca-col>
              </ca-row>
            </ca-field>
          </ca-col>

          <ca-col size="3">
            <ca-field label="Registro Eletrônico de Empregados">
              <ca-row>
                <ca-col size="4">
                  <ca-checkbox
                    v-model="company.indElectEmployeeRegistry"
                    label="Sim" />
                </ca-col>
              </ca-row>
            </ca-field>
          </ca-col>

          <ca-col size="3">
            <ca-field label="Participação no PAT">
              <ca-row>
                <ca-col size="4">
                  <ca-checkbox
                    v-model="company.indPatParticipation"
                    label="Sim" />
                </ca-col>
              </ca-row>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Fator Acidentário de Prevenção(FAP)">
              <percent-input
                v-model="company.fap"
                :integer-places="1"
                :decimal-places="2"
                :custom-validations="fapCustomValidations"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Nome do Contato">
              <ca-input
                v-model="company.contactName"
                maxlength="60"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="CPF do Contato">
              <ca-cpf-input
                v-model="company.contactDocument"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Telefone do Contato">
              <ca-input
                v-model="company.contactPhone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                :required="isPhoneRequired" />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Celular do Contato">
              <ca-input
                v-model="company.contactCellphone"
                mask-pattern="(99) 99999-9999"
                :on-blur="refreshForm" />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Email do Contato">
              <ca-email-input
                v-model="company.contactEmail"
                maxlength="60" />
            </ca-field>
          </ca-col>

          <ca-col v-if="isLegalInscription" size="6">
            <ca-field label="Situação Pessoa Jurídica">
              <ca-select v-model="company.legalEntitySituation.name" :on-change="refreshForm">
                <ca-option
                  v-for="situation in misc.pjSituations"
                  :key="situation.value"
                  :value="situation.name">
                  {{ situation.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col v-else size="6">
            <ca-field label="Situação Pessoa Física">
              <ca-select v-model="company.naturalPersonSituation.name" :on-change="refreshForm">
                <ca-option
                  v-for="situation in misc.pfSituations"
                  :key="situation.value"
                  :value="situation.name">
                  {{ situation.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Data de Fundação">
              <ca-date-input
                v-model="company.registrationDate"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Contagem de horas para Horistas">
              <ca-select v-model="company.hourlyCountType.name" :on-change="refreshForm">
                <ca-option
                  v-for="item in misc.hourlyCountingHours"
                  :key="item.value"
                  :value="item.name">
                  {{ item.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field
              label="Situação no eSocial">
              <ca-select
                v-model="company.statusEsocial.name"
                :on-change="refreshForm"
                required>
                <ca-option
                  v-for="status in misc.esocialStatus.default"
                  :key="status.value"
                  :value="status.name">
                  {{ status.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Arredondar Centavos de Líquidos">
              <ca-checkbox v-model="company.indRounding" label="Sim" />
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-heading text="Informações bancárias" size="small" />
        <hr />
        <ca-row>
          <ca-col size="6">
            <ca-field label="Banco">
              <ca-select v-model="companyBank" :on-change="refreshForm">
                <ca-option :key="'EMPTY'" :value="'EMPTY'">N/A</ca-option>
                <ca-option
                  v-for="bank in misc.banks"
                  :key="bank.name"
                  :value="bank.name">
                  {{ bank.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Agência">
              <ca-input
                v-model="company.bankAgency"
                maxlength="7" />
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Conta Corrente">
              <ca-input
                v-model="company.bankAccount"
                maxlength="14" />
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Convênio">
              <ca-input
                v-model="company.bankAgreement"
                maxlength="20" />
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field
              label="Imprimir contas no holerite"
              icon-tooltip="Imprimir informações de conta bancária do trabalhador em seu recibo">
              <ca-checkbox v-model="company.indBankReceipt" label="Sim" />
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Mensagem nos recibos">
              <ca-input v-model="company.receiptMessage" maxlength="100" />
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject, getBoxInformationErrorMessage } from 'packages/common/utils';
import ReferenceDaysCountingModal from './modals/ReferenceDaysCountingModal';
import { getEmployer, editEmployer, FAPValidation } from './employerService';

export default {
  name: 'EmployerForm',
  data() {
    return {
      formKey: 0,
      company: initFormObject(),
      companyBank: 'EMPTY',
      errorMessage: null,
    };
  },
  computed: {
    showLoading() {
      return this.company.loading;
    },
    misc() {
      return this.$store.state.misc;
    },
    isLegalInscription() {
      return this.company.registrationType === 'J';
    },
    isPhoneRequired() {
      return !this.company.contactCellphone;
    },
    fapCustomValidations(value) {
      return FAPValidation(value);
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getCompanyInscriptionType', 'EMPRESAS');
      this.$store.dispatch('misc/getTributaryClassifications');
      this.$store.dispatch('misc/getMonthlyCountingDays');
      this.$store.dispatch('misc/getCooperativeCallsigns');
      this.$store.dispatch('misc/getPFSituations');
      this.$store.dispatch('misc/getPJSituations');
      this.$store.dispatch('misc/getEsocialStatus');
      this.$store.dispatch('misc/getBanks');
      this.$store.dispatch('misc/getHourlyCountingHours');
      this.$store.dispatch('misc/getLegalNatures');
      this.$store.dispatch('misc/getCompanySizes');

      this.setEmployer();
    },
    async setEmployer() {
      this.company = await getEmployer();
      this.companyBank = this.company.bankCode.name || 'EMPTY';
    },
    goBack() {
      this.$router.push({ name: 'EmployerView' });
    },
    onSubmit() {
      this.company.bankCode = this.companyBank === 'EMPTY' ? null : { name: this.companyBank };
      return editEmployer(this.company);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    onReferenceDaysCounting() {
      this.$dialogModal(ReferenceDaysCountingModal).open();
    },
    async onChangeLegalNature() {
      await this.$nextTick();
      this.refreshForm();
    },
    refreshForm() {
      this.formKey++;
    },
  },
};
</script>

<style scoped>
.dp-ca-u-margin-top {
  margin-top: 22px !important;
}
</style>
